export default {
    methods: {
        showInfo(infoKeyword, fromInfoList = true) {
            this.$eventBus.$emit('info-show', infoKeyword, fromInfoList);
        },
        hideInfo() {
            this.$eventBus.$emit('info-remove');
        },
    }
};

const highlightMethod = {
    methods: {
        highlightInfo(infoKeyword, fromInfoList = true) {
            return {
                over: () => {
                    this.$eventBus.$emit('info-show', infoKeyword, fromInfoList);
                },
                leave: () => {
                    this.$eventBus.$emit('info-remove', infoKeyword);
                },
            }
        }
    }
};

export {highlightMethod};
